function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/liveposition
 */
import Position from './position';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * `LivePosition` is a type of {@link module:engine/model/position~Position Position}
 * that updates itself as {@link module:engine/model/document~Document document}
 * is changed through operations. It may be used as a bookmark.
 *
 * **Note:** Contrary to {@link module:engine/model/position~Position}, `LivePosition` works only in roots that are
 * {@link module:engine/model/rootelement~RootElement}.
 * If {@link module:engine/model/documentfragment~DocumentFragment} is passed, error will be thrown.
 *
 * **Note:** Be very careful when dealing with `LivePosition`. Each `LivePosition` instance bind events that might
 * have to be unbound.
 * Use {@link module:engine/model/liveposition~LivePosition#detach} whenever you don't need `LivePosition` anymore.
 *
 * @extends module:engine/model/position~Position
 */

var LivePosition =
/*#__PURE__*/
function (_Position) {
  _inherits(LivePosition, _Position);

  /**
   * Creates a live position.
   *
   * @see module:engine/model/position~Position
   * @param {module:engine/model/rootelement~RootElement} root
   * @param {Array.<Number>} path
   * @param {module:engine/model/position~PositionStickiness} [stickiness]
   */
  function LivePosition(root, path) {
    var _this;

    var stickiness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'toNone';

    _classCallCheck(this, LivePosition);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LivePosition).call(this, root, path, stickiness));

    if (!_this.root.is('rootElement')) {
      /**
       * LivePosition's root has to be an instance of RootElement.
       *
       * @error model-liveposition-root-not-rootelement
       */
      throw new CKEditorError('model-liveposition-root-not-rootelement', root);
    }

    bindWithDocument.call(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Unbinds all events previously bound by `LivePosition`. Use it whenever you don't need `LivePosition` instance
   * anymore (i.e. when leaving scope in which it was declared or before re-assigning variable that was
   * referring to it).
   */


  _createClass(LivePosition, [{
    key: "detach",
    value: function detach() {
      this.stopListening();
    }
    /**
     * Checks whether this object is of the given.
     *
     *		livePosition.is( 'position' ); // -> true
     *		livePosition.is( 'model:position' ); // -> true
     *		livePosition.is( 'liveposition' ); // -> true
     *		livePosition.is( 'model:livePosition' ); // -> true
     *
     *		livePosition.is( 'view:position' ); // -> false
     *		livePosition.is( 'documentSelection' ); // -> false
     *
     * {@link module:engine/model/node~Node#is Check the entire list of model objects} which implement the `is()` method.
     *
     * @param {String} type
     * @returns {Boolean}
     */

  }, {
    key: "is",
    value: function is(type) {
      return type === 'livePosition' || type === 'model:livePosition' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
      type == 'position' || type === 'model:position';
    }
    /**
     * Creates a {@link module:engine/model/position~Position position instance}, which is equal to this live position.
     *
     * @returns {module:engine/model/position~Position}
     */

  }, {
    key: "toPosition",
    value: function toPosition() {
      return new Position(this.root, this.path.slice(), this.stickiness);
    }
    /**
     * Creates a `LivePosition` instance that is equal to position.
     *
     * @param {module:engine/model/position~Position} position
     * @param {module:engine/model/position~PositionStickiness} [stickiness]
     * @returns {module:engine/model/position~Position}
     */

  }], [{
    key: "fromPosition",
    value: function fromPosition(position, stickiness) {
      return new this(position.root, position.path.slice(), stickiness ? stickiness : position.stickiness);
    }
    /**
     * @static
     * @protected
     * @method module:engine/model/liveposition~LivePosition._createAfter
     * @see module:engine/model/position~Position._createAfter
     * @param {module:engine/model/node~Node} node
     * @param {module:engine/model/position~PositionStickiness} [stickiness='toNone']
     * @returns {module:engine/model/liveposition~LivePosition}
     */

    /**
     * @static
     * @protected
     * @method module:engine/model/liveposition~LivePosition._createBefore
     * @see module:engine/model/position~Position._createBefore
     * @param {module:engine/model/node~Node} node
     * @param {module:engine/model/position~PositionStickiness} [stickiness='toNone']
     * @returns {module:engine/model/liveposition~LivePosition}
     */

    /**
     * @static
     * @protected
     * @method module:engine/model/liveposition~LivePosition._createAt
     * @see module:engine/model/position~Position._createAt
     * @param {module:engine/model/item~Item|module:engine/model/position~Position} itemOrPosition
     * @param {Number|'end'|'before'|'after'} [offset]
     * @param {module:engine/model/position~PositionStickiness} [stickiness='toNone']
     * @returns {module:engine/model/liveposition~LivePosition}
     */

    /**
     * Fired when `LivePosition` instance is changed due to changes on {@link module:engine/model/document~Document}.
     *
     * @event module:engine/model/liveposition~LivePosition#change
     * @param {module:engine/model/position~Position} oldPosition Position equal to this live position before it got changed.
     */

  }]);

  return LivePosition;
}(Position); // Binds this `LivePosition` to the {@link module:engine/model/document~Document document} that owns
// this position's {@link module:engine/model/position~Position#root root}.
//
// @private


export { LivePosition as default };

function bindWithDocument() {
  var _this2 = this;

  this.listenTo(this.root.document.model, 'applyOperation', function (event, args) {
    var operation = args[0];

    if (!operation.isDocumentOperation) {
      return;
    }

    transform.call(_this2, operation);
  }, {
    priority: 'low'
  });
} // Updates this position accordingly to the updates applied to the model. Bases on change events.
//
// @private
// @param {module:engine/model/operation/operation~Operation} operation Executed operation.


function transform(operation) {
  var result = this.getTransformedByOperation(operation);

  if (!this.isEqual(result)) {
    var oldPosition = this.toPosition();
    this.path = result.path;
    this.root = result.root;
    this.fire('change', oldPosition);
  }
}

mix(LivePosition, EmitterMixin);